export default __webpack_public_path__ + "static/img/birthday_cell_icon.31224d5.svg";